import SlashCommand from './slash-command';

export default SlashCommand;
